/* eslint-disable */
import { Directive, HostListener, Input, TemplateRef } from '@angular/core';
import { QuickModal } from '@egovsolutions/angular-quick-modal';

@Directive({
  selector: '[appModal]'
})
export class ModalDirective
{
    @Input('appModal') public content?: string | TemplateRef<any>;

    constructor
    (
        private readonly quickModal: QuickModal,
    )
    {}

    @HostListener('click') public onClick()
    {
        if (this.content) this.quickModal.show(this.content);
    }
}
